let pending;
export function loadYouTubeApi() {
    if (window.YT?.Player) return Promise.resolve(window.YT);
    if (pending) return pending;
    pending = new Promise((resolve, reject) => {
        const previous = window.onYouTubeIframeAPIReady;
        const script = document.createElement('script');
        const timeout = setTimeout(() => { script.remove(); pending = null; reject(new Error('YouTube ne répond pas. Réessayez.')); }, 20000);
        window.onYouTubeIframeAPIReady = () => {
            clearTimeout(timeout);
            if (typeof previous === 'function') previous();
            resolve(window.YT);
        };
        script.src = 'https://www.youtube.com/iframe_api';
        script.onerror = () => { clearTimeout(timeout); script.remove(); pending = null; reject(new Error('Impossible de charger YouTube. Vérifiez votre connexion.')); };
        document.head.appendChild(script);
    });
    return pending;
}
